import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const SRIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="SR" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#4E8B1D"
        fillRule="evenodd"
        d="M0 8h16v4H0V8ZM0 0h16v3H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#AF0100"
        stroke="#fff"
        strokeWidth={1.5}
        d="M16.75 3.25v5.5H-.75v-5.5h17.5Z"
      />
      <Path
        fill="#FECA00"
        fillRule="evenodd"
        d="M8.001 7.247 6.754 8l.285-1.47L6 5.432l1.406-.06L8.001 4l.595 1.372H10L8.964 6.53 9.276 8 8 7.247Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
